import { NavLink } from "react-router-dom";

const tabs = [
  { label: "首页", icon: "ri-home-5-line", to: "/" },
  { label: "电影", icon: "ri-movie-2-line", to: "/category/movie" },
  { label: "电视剧", icon: "ri-tv-2-line", to: "/category/tv" },
  { label: "资讯", icon: "ri-newspaper-line", to: "/news" },
  { label: "关于", icon: "ri-information-line", to: "/about" },
];

export default function MobileTabBar() {
  return (
    <nav
      aria-label="底部导航"
      className="fixed bottom-0 left-0 right-0 z-40 border-t border-background-200 bg-background-50/95 backdrop-blur-md md:hidden"
    >
      <div className="grid w-full grid-cols-5">
        {tabs.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            end={tab.to === "/"}
            className={({ isActive }) =>
              [
                "flex min-h-[56px] cursor-pointer flex-col items-center justify-center gap-1 text-[11px] transition-colors",
                isActive ? "text-accent-700" : "text-foreground-500",
              ].join(" ")
            }
          >
            {({ isActive }) => (
              <>
                <span className="flex h-6 w-6 items-center justify-center">
                  <i className={`${tab.icon} text-lg ${isActive ? "text-accent-600" : ""}`}></i>
                </span>
                <span className={isActive ? "font-medium" : ""}>{tab.label}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}